import React, { useEffect, useRef, useCallback, useState } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";


// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "components/Common/withRouter";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";
import { routes } from "routes/path";

const SidebarContent = props => {

  const [RoleName, setRoleName] = useState(
    JSON.parse(localStorage?.getItem("authUser"))
  )
  const [TaskTitleTypes, setTaskTitleTypes] = useState(
    (JSON.parse(localStorage?.getItem("authUser")).TaskTitleTypes)
  )
  const ref = useRef();
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();
  const activeMenu = useCallback(() => {
    let pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (
        pathName == routes.rentmakingcreate
        || pathName == routes.rentmakingupdate
      ) {
        pathName = routes.rentmakinglist
      }
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          {RoleName.FromAttendanceUser == true ?
            <>
              <ul className="metismenu list-unstyled" id="side-menu">
                <li>
                  <Link to="/#" className="has-arrow">
                    <i style={{ fontSize: "18px" }} className="fas fa-users-cog"></i>
                    <span>{props.t("Attendance")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to={routes.attendanceLog}>{props.t("Attendance Log")}</Link>
                    </li>
                    <li>
                      <Link to={routes.employeeSalary}>{props.t("Salary")}</Link>
                    </li>
                    <li>
                      <Link to={routes.advanceLog}>{props.t("Advance Log")}</Link>
                    </li>
                    <li>
                      <Link to={routes.leave}>{props.t("Leave")}</Link>
                    </li>
                    <li>
                      <Link to={routes.attendanceReport}>{props.t("Monthly Report")}</Link>
                    </li>
                    <li>
                      <Link to={routes.dailyAttendanceReport}>{props.t("Daily Report")}</Link>
                    </li>
                  </ul>
                </li>

              </ul>
            </>
            :
            <>
              {RoleName.RoleName == "Admin" ?
                <>
                  <ul className="metismenu list-unstyled" id="side-menu">
                    <li className="menu-title">{props.t("Menu")} </li>
                    <li>
                      <Link to={routes.dashboard} className="">
                        <i className="bx bx-home-circle"></i>
                        <span>{props.t("Dashboards")}</span>
                      </Link>
                    </li>
                    {/* <li>
                      <Link to="/#" className="has-arrow">
                        <i className="bx bx-file"></i>
                        <span>{props.t("Master")}</span>
                      </Link>
                      <ul className="sub-menu">
                        <li>
                          <Link to={routes.userList}>{props.t("User")}</Link>
                        </li>
                        <li>
                          <Link to={routes.taskTitle}>{props.t("Task Title")}</Link>
                        </li>
                        <li>
                          <Link to={routes.leadType}>{props.t("Lead Type")}</Link>
                        </li>
                        <li>
                          <Link to={routes.categories}>{props.t("Categories")}</Link>
                        </li>
                        <li>
                          <Link to={routes.occasion}>{props.t("Occasions")}</Link>
                        </li>
                        <li>
                          <Link to={routes.whatsAppMessage}>{props.t("WhatsApp Message")}</Link>
                        </li>
                        <li>
                          <Link to={routes.vendors}>{props.t("Vendors")}</Link>
                        </li>
                        <li>
                          <Link to={routes.workers}>{props.t("Workers")}</Link>
                        </li>
                        <li>
                          <Link to={routes.otherCost}>{props.t("Other Cost")}</Link>
                        </li>
                        <li>
                          <Link to={routes.stitchingWorkers}>{props.t("Stitching Workers")}</Link>
                        </li>
                        <li>
                          <Link to={routes.stitchingMasters}>{props.t("Stitching Masters")}</Link>
                        </li>
                        <li>
                          <Link to={routes.workerHoliday}>{props.t("Worker Holidays")}</Link>
                        </li>
                        <li>
                          <Link to={routes.attendanceUser}>{props.t("Attendance User")}</Link>
                        </li>
                        <li>
                          <Link to={routes.rackshelf}>{props.t("Rack Shelf")}</Link>
                        </li>
                      </ul>
                    </li> */}
                    {/* <li>
                      <Link to={routes.task} className="">
                        <i className="bx bx-task"></i>
                        <span>{props.t("Task")}</span>
                      </Link>
                    </li> */}
                    <li>
                      <Link to={routes.lead} className="">
                        <i className="bx bx-file"></i>
                        <span>{props.t("Lead")}</span>
                      </Link>
                    </li>

                    <li>
                      <Link to={routes.parcel} className="">
                        <i className="bx bx-box"></i>
                        <span>{props.t("Parcel")}</span>
                      </Link>
                    </li>
                    <li>
                      <Link to={routes.appointment} className="">
                        <i className="mdi mdi-calendar-clock"></i>
                        <span>{props.t("Appointment")}</span>
                      </Link>
                    </li>
                    <li>
                      <Link to={routes.making} className="">
                        <i className="mdi mdi-account-reactivate"></i>
                        <span>{props.t("Making")}</span>
                      </Link>
                    </li>
                    <li>
                      <Link to={routes.CustomerAttend} className="">
                        <i style={{ fontSize: "15px" }} className="fas fa-user-friends"></i>
                        <span>{props.t("Customer Attend")}</span>
                      </Link>
                    </li>
                    <li>
                      <Link to={routes.dcHanging} className="">
                        <i style={{ fontSize: "20px" }} className="mdi mdi-hair-dryer-outline"></i>
                        <span>{props.t("DC Hanging")}</span>
                      </Link>
                    </li>
                    <li>
                      <Link to={routes.fabric} className="">
                        <i className="bx bx-poll"></i>
                        <span>{props.t("Requirements")}</span>
                      </Link>
                    </li>
                    <li>
                      <Link to={routes.drawRequirement} className="">
                        <i style={{ fontSize: "18px" }} className="far fa-file-image"></i>
                        <span>{props.t("Draw Requirement")}</span>
                      </Link>
                    </li>
                    <li>
                      <Link to={routes.cuttingRequirement} className="">
                        <i style={{ fontSize: "18px" }} className="fas fa-cut"></i>
                        <span>{props.t("Cutting Requirement")}</span>
                      </Link>
                    </li>
                    <li>
                      <Link to={routes.additionalWork} className="">
                        <i style={{ fontSize: "21px" }} className="mdi mdi-file-document-edit-outline"></i>
                        <span>{props.t("Additional Work")}</span>
                      </Link>
                    </li>
                    <li>
                      <Link to={routes.improvement} className="">
                        <i style={{ fontSize: "20px" }} className="mdi mdi-inbox-arrow-up-outline"></i>
                        <span>{props.t("Improvement")}</span>
                      </Link>
                    </li>
                    <li>
                      <Link to={routes.rentmakinglist} className="">
                        <i style={{ fontSize: "20px" }} className="mdi mdi-note-text-outline"></i>
                        <span>{props.t("Un-Bill")}</span>
                      </Link>
                    </li>
                    {/* <li>
                      <Link to={routes.purchaseBill} className="">
                        <i style={{ fontSize: "20px" }} className="bx bx-purchase-tag-alt"></i>
                        <span>{props.t("Purchase Bill")}</span>
                      </Link>
                    </li> */}
                    <li>
                      <Link to={routes.handWorkOrder} className="">
                        <i style={{ fontSize: "18px" }} className="fas fa-list"></i>
                        <span>{props.t("Hand Work Order")}</span>
                      </Link>
                    </li>
                    <li>
                      <Link to={routes.handWork} className="">
                        <i style={{ fontSize: "18px" }} className="fas fa-feather-alt"></i>
                        <span>{props.t("Hand Work")}</span>
                      </Link>
                    </li>
                    {/* <li>
                      <Link to={routes.khaKhaRack} className="">
                        <i style={{ fontSize: "18px" }} className="fas fa-inbox"></i>
                        <span>{props.t("Rack Shelf")}</span>
                      </Link>
                    </li> */}
                    <li>
                      <Link to="/#" className="has-arrow">
                        <i style={{ fontSize: "18px" }} className="fas fa-inbox"></i>
                        <span>{props.t("Rack")}</span>
                      </Link>
                      <ul className="sub-menu">
                        <li>
                          <Link to={routes.khaKhaRack}>{props.t("Kha-Kha")}</Link>
                        </li>
                        <li>
                          <Link to={routes.materialRack}>{props.t("Material")}</Link>
                        </li>
                      </ul>
                    </li>
                    {/* <li>
                      <Link to="/#" className="has-arrow">
                        <i style={{ fontSize: "18px" }} className="fas fa-users-cog"></i>
                        <span>{props.t("Attendance")}</span>
                      </Link>
                      <ul className="sub-menu">
                        <li>
                          <Link to={routes.attendanceLog}>{props.t("Attendance Log")}</Link>
                        </li>
                        <li>
                          <Link to={routes.employeeSalary}>{props.t("Salary")}</Link>
                        </li>
                        <li>
                          <Link to={routes.advanceLog}>{props.t("Advance Log")}</Link>
                        </li>
                        <li>
                          <Link to={routes.leave}>{props.t("Leave")}</Link>
                        </li>
                        <li>
                          <Link to={routes.attendanceReport}>{props.t("Monthly Report")}</Link>
                        </li>
                        <li>
                          <Link to={routes.dailyAttendanceReport}>{props.t("Daily Report")}</Link>
                        </li>
                      </ul>
                    </li> */}
                    {/* <li>
                      <Link to="/#" className="has-arrow">
                        <i className="fas fa-chart-bar"></i>
                        <span>{props.t("Report")}</span>
                      </Link>
                      <ul className="sub-menu">
                        <li>
                          <Link to={routes.taskReport}>{props.t("Task")}</Link>
                        </li>
                        <li>
                          <Link to={routes.unBillReport}>{props.t("Un-Bill")}</Link>
                        </li>
                        <li>
                          <Link to={routes.customerAttendReport}>{props.t("Customer Attend")}</Link>
                        </li>
                      </ul>
                    </li> */}
                    {/* <li>
                      <Link to={routes.sendMessgae}>
                        <i className="bx bx-message-dots"></i>
                        <span>{props.t("SOP")}</span>
                      </Link>
                    </li> */}
                    <li>
                      <Link to={routes.helpNeeded} className="">
                        <i style={{ fontSize: "22px" }} className="bx bx-help-circle"></i>
                        <span>{props.t("Help Needed")}</span>
                      </Link>
                    </li>
                    {/* <li>
                      <Link to={routes.setting}>
                        <i className="bx bxs-cog"></i>
                        <span>{props.t("Setting")}</span>
                      </Link>
                    </li> */}
                    {/* <li>
                      <Link to={routes.dbBackup}>
                        <i className="bx bxs-data"></i>
                        <span>{props.t("Db-Backup")}</span>
                      </Link>
                    </li> */}
                  </ul>
                </>
                :
                RoleName.RoleName == "Master" ?
                  <>
                    <ul className="metismenu list-unstyled" id="side-menu">
                      <li className="menu-title">{props.t("Menu")} </li>
                      <li>
                        <Link to="/#" className="has-arrow">
                          <i className="bx bx-file"></i>
                          <span>{props.t("Master")}</span>
                        </Link>
                        <ul className="sub-menu">
                          <li>
                            <Link to={routes.userList}>{props.t("User")}</Link>
                          </li>
                          <li>
                            <Link to={routes.taskTitle}>{props.t("Task Title")}</Link>
                          </li>
                          <li>
                            <Link to={routes.leadType}>{props.t("Lead Type")}</Link>
                          </li>
                          <li>
                            <Link to={routes.categories}>{props.t("Categories")}</Link>
                          </li>
                          <li>
                            <Link to={routes.occasion}>{props.t("Occasions")}</Link>
                          </li>
                          <li>
                            <Link to={routes.whatsAppMessage}>{props.t("WhatsApp Message")}</Link>
                          </li>
                          <li>
                            <Link to={routes.vendors}>{props.t("Vendors")}</Link>
                          </li>
                          <li>
                            <Link to={routes.workers}>{props.t("Workers")}</Link>
                          </li>
                          <li>
                            <Link to={routes.otherCost}>{props.t("Other Cost")}</Link>
                          </li>
                          <li>
                            <Link to={routes.stitchingWorkers}>{props.t("Stitching Workers")}</Link>
                          </li>
                          <li>
                            <Link to={routes.stitchingMasters}>{props.t("Stitching Masters")}</Link>
                          </li>
                          <li>
                            <Link to={routes.workerHoliday}>{props.t("Worker Holidays")}</Link>
                          </li>
                          <li>
                            <Link to={routes.attendanceUser}>{props.t("Attendance User")}</Link>
                          </li>
                          <li>
                            <Link to={routes.rackshelf}>{props.t("Rack Shelf")}</Link>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <Link to={routes.task} className="">
                          <i className="bx bx-task"></i>
                          <span>{props.t("Task")}</span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/#" className="has-arrow">
                          <i className="fas fa-chart-bar"></i>
                          <span>{props.t("Report")}</span>
                        </Link>
                        <ul className="sub-menu">
                          <li>
                            <Link to={routes.taskReport}>{props.t("Task")}</Link>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <Link to={routes.sendMessgae}>
                          <i className="bx bx-message-dots"></i>
                          <span>{props.t("SOP")}</span>
                        </Link>
                      </li>
                      <li>
                        <Link to={routes.purchaseBill} className="">
                          <i style={{ fontSize: "20px" }} className="bx bx-purchase-tag-alt"></i>
                          <span>{props.t("Purchase Bill")}</span>
                        </Link>
                      </li>
                      <li>
                        <li>
                          <Link to="/#" className="has-arrow">
                            <i style={{ fontSize: "18px" }} className="fas fa-users-cog"></i>
                            <span>{props.t("Attendance")}</span>
                          </Link>
                          <ul className="sub-menu">
                            <li>
                              <Link to={routes.attendanceLog}>{props.t("Attendance Log")}</Link>
                            </li>
                            <li>
                              <Link to={routes.employeeSalary}>{props.t("Salary")}</Link>
                            </li>
                            <li>
                              <Link to={routes.advanceLog}>{props.t("Advance Log")}</Link>
                            </li>
                            <li>
                              <Link to={routes.leave}>{props.t("Leave")}</Link>
                            </li>
                            <li>
                              <Link to={routes.attendanceReport}>{props.t("Monthly Report")}</Link>
                            </li>
                            <li>
                              <Link to={routes.dailyAttendanceReport}>{props.t("Daily Report")}</Link>
                            </li>
                          </ul>
                        </li>
                        <Link to={routes.setting}>
                          <i className="bx bxs-cog"></i>
                          <span>{props.t("Setting")}</span>
                        </Link>
                      </li>
                      <li>
                        <Link to={routes.dbBackup}>
                          <i className="bx bxs-data"></i>
                          <span>{props.t("Db-Backup")}</span>
                        </Link>
                      </li>
                    </ul>
                  </>
                  :
                  <>
                    <ul className="metismenu list-unstyled" id="side-menu">
                      <li className="menu-title">{props.t("Menu")} </li>
                      <li>
                        <Link to={routes.dashboard} className="">
                          <i className="bx bx-home-circle"></i>
                          <span>{props.t("Dashboards")}</span>
                        </Link>
                      </li>
                      <li>
                        <Link to={routes.task} className="">
                          <i className="bx bx-task"></i>
                          <span>{props.t("Task")}</span>
                        </Link>
                      </li>
                      {(TaskTitleTypes || TaskTitleTypes != null) && (
                        <>
                          {(TaskTitleTypes.includes("2") || TaskTitleTypes.includes("7")) && (
                            <li>
                              <Link to={routes.lead} className="">
                                <i className="bx bx-file"></i>
                                <span>{props.t("Lead")}</span>
                              </Link>
                            </li>
                          )}

                          {TaskTitleTypes.includes("3") && (
                            <li>
                              <Link to={routes.parcel} className="">
                                <i className="bx bx-box"></i>
                                <span>{props.t("Parcel")}</span>
                              </Link>
                            </li>
                          )}

                          {TaskTitleTypes.includes("4") && (
                            <li>
                              <Link to={routes.appointment} className="">
                                <i className="mdi mdi-calendar-clock"></i>
                                <span>{props.t("Appointment")}</span>
                              </Link>
                            </li>
                          )}

                          {TaskTitleTypes.includes("5") && (
                            <li>
                              <Link to={routes.making} className="">
                                <i className="mdi mdi-account-reactivate"></i>
                                <span>{props.t("Making")}</span>
                              </Link>
                            </li>
                          )}

                          {TaskTitleTypes.includes("6") && (
                            <li>
                              <Link to={routes.CustomerAttend} className="">
                                <i style={{ fontSize: "15px" }} className="fas fa-user-friends"></i>
                                <span>{props.t("Customer Attend")}</span>
                              </Link>
                            </li>
                          )}
                          {TaskTitleTypes.includes("8") && (
                            <li>
                              <Link to={routes.dcHanging} className="">
                                <i style={{ fontSize: "20px" }} className="mdi mdi-hair-dryer-outline"></i>
                                <span>{props.t("DC Hanging")}</span>
                              </Link>
                            </li>
                          )}
                          {(TaskTitleTypes.includes("9") || TaskTitleTypes.includes("10")) && (
                            <li>
                              <Link to={routes.fabric} className="">
                                <i className="bx bx-poll"></i>
                                <span>{props.t("Requirements")}</span>
                              </Link>
                            </li>
                          )}
                          {(TaskTitleTypes.includes("18") || TaskTitleTypes.includes("19")) && (
                            <li>
                              <Link to={routes.drawRequirement} className="">
                                <i style={{ fontSize: "18px" }} className="far fa-file-image"></i>
                                <span>{props.t("Draw Requirement")}</span>
                              </Link>
                            </li>
                          )}
                          {(TaskTitleTypes.includes("20") || TaskTitleTypes.includes("21")) && (
                            <li>
                              <Link to={routes.cuttingRequirement} className="">
                                <i style={{ fontSize: "18px" }} className="fas fa-cut"></i>
                                <span>{props.t("Cutting Requirement")}</span>
                              </Link>
                            </li>
                          )}
                          {TaskTitleTypes.includes("13") && (
                            <li>
                              <Link to={routes.purchaseBill} className="">
                                <i style={{ fontSize: "20px" }} className="bx bx-purchase-tag-alt"></i>
                                <span>{props.t("Purchase Bill")}</span>
                              </Link>
                            </li>
                          )}
                          {(TaskTitleTypes.includes("11") || TaskTitleTypes.includes("12")) && (
                            <li>
                              <Link to={routes.rentmakinglist} className="">
                                <i style={{ fontSize: "20px" }} className="mdi mdi-note-text-outline"></i>
                                <span>{props.t("Un-Bill")}</span>
                              </Link>
                            </li>
                          )}
                          {(TaskTitleTypes.includes("16") || (TaskTitleTypes.includes("17")) || TaskTitleTypes.includes("14")) && (
                            <li>
                              <Link to={routes.handWorkOrder} className="">
                                <i style={{ fontSize: "18px" }} className="fas fa-list"></i>
                                <span>{props.t("Hand Work Order")}</span>
                              </Link>
                            </li>
                          )}

                          {/* {(TaskTitleTypes.includes("14")) && (
                      <li>
                        <Link to={routes.designerOrder} className="">
                          <i style={{ fontSize: "18px" }} className="fas fa-list"></i>
                          <span>{props.t("Hand Work Order")}</span>
                        </Link>
                      </li>
                    )}
                    {(TaskTitleTypes.includes("17")) && (
                      <li>
                        <Link to={routes.stitchingOrder} className="">
                          <i style={{ fontSize: "18px" }} className="fas fa-list"></i>
                          <span>{props.t("Hand Work Order")}</span>
                        </Link>
                      </li>
                    )} */}
                          {(TaskTitleTypes.includes("14") || TaskTitleTypes.includes("15")) && (
                            <li>
                              <Link to={routes.handWork} className="">
                                <i style={{ fontSize: "18px" }} className="fas fa-feather-alt"></i>
                                <span>{props.t("Hand Work")}</span>
                              </Link>
                            </li>
                          )}
                          <li>
                            <Link to="/#" className="has-arrow">
                              <i style={{ fontSize: "18px" }} className="fas fa-inbox"></i>
                              <span>{props.t("Rack")}</span>
                            </Link>
                            <ul className="sub-menu">
                              <li>
                                <Link to={routes.khaKhaRack}>{props.t("Kha-Kha")}</Link>
                              </li>
                              <li>
                                <Link to={routes.materialRack}>{props.t("Material")}</Link>
                              </li>
                            </ul>
                          </li>
                          <li>
                            <Link to="/#" className="has-arrow">
                              <i style={{ fontSize: "18px" }} className="fas fa-users-cog"></i>
                              <span>{props.t("Attendance")}</span>
                            </Link>
                            <ul className="sub-menu">
                              <li>
                                <Link to={routes.attendanceLog}>{props.t("Attendance Log")}</Link>
                              </li>
                              <li>
                                <Link to={routes.employeeSalary}>{props.t("Salary")}</Link>
                              </li>
                              <li>
                                <Link to={routes.advanceLog}>{props.t("Advance Log")}</Link>
                              </li>
                              <li>
                                <Link to={routes.leave}>{props.t("Leave")}</Link>
                              </li>
                              <li>
                                <Link to={routes.attendanceReport}>{props.t("Monthly Report")}</Link>
                              </li>
                              <li>
                                <Link to={routes.dailyAttendanceReport}>{props.t("Daily Report")}</Link>
                              </li>
                            </ul>
                          </li>
                        </>
                      )}
                      <li>
                        <Link to={routes.helpNeeded} className="">
                          <i style={{ fontSize: "22px" }} className="bx bx-help-circle"></i>
                          <span>{props.t("Help Needed")}</span>
                        </Link>
                      </li>
                      <li>
                        <Link to={routes.additionalWork} className="">
                          <i style={{ fontSize: "21px" }} className="mdi mdi-file-document-edit-outline"></i>
                          <span>{props.t("Additional Work")}</span>
                        </Link>
                      </li>
                      <li>
                        <Link to={routes.improvement} className="">
                          <i style={{ fontSize: "20px" }} className="mdi mdi-inbox-arrow-up-outline"></i>
                          <span>{props.t("Improvement")}</span>
                        </Link>
                      </li>
                      <li>
                        <Link to={routes.sendMessgae}>
                          <i className="bx bx-message-dots"></i>
                          <span>{props.t("SOP")}</span>
                        </Link>
                      </li>
                    </ul>
                  </>
              }
            </>
          }

        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
